export const CATEGORY_OPTIONS = [
  { value: '', label: 'All Categories' },
  { value: 'banner', label: 'Banner' },
  { value: 'poster', label: 'Poster' },
  { value: 'document', label: 'Document' },
  { value: 'video', label: 'Video' },
  { value: 'infographic', label: 'Infographic' },
];

export const STATUS_OPTIONS = [
  { value: '', label: 'All Statuses' },
  { value: 'active', label: 'Active' },
  { value: 'inactive', label: 'Inactive' },
  { value: 'draft', label: 'Draft' },
];

